import React from 'react';

const NotFound = () => {
 return (
  <div>
   <h3>Page not found </h3>
  </div>
 );
};

export default NotFound;